import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-not-found-modal',
  templateUrl: './not-found-modal.component.html',
  styleUrls: ['./not-found-modal.component.scss']
})
export class NotFoundModalComponent implements OnInit {
  @Output() retryScan = new EventEmitter<null>();
  @Output() closed = new EventEmitter<null>();
  public qrCode: string;
  private route: ActivatedRoute;
  constructor(
    public bsModalRef: BsModalRef,
    private router: Router
  ) { }

  @ViewChild('template', { static: false }) template: TemplateRef<any>;

  ngOnInit() {
  }

  retry(): void {
    this.retryScan.emit();
    this.closed.emit();
    this.bsModalRef.hide();
  }

  home(): void {
    this.closed.emit();
    this.bsModalRef.hide();
    this.router.navigate(['..'], {relativeTo: this.route});
  }
}
